/* ============================================================
   PDP de productos normales — misma mecánica que las landings (SOFS Basics / Polos).
   SOLO COMPUTADOR (>=1024px). En celular no se toca nada: si la pantalla es chica
   el script no hace nada y el theme queda como estaba.

   Arma: [ tira de miniaturas ][ foto grande ] y deja visible una sola foto.
   - Clic en una miniatura → esa queda de foto grande (marco rosado).
   - Flechas ‹ › sobre la foto grande (aparecen al pasar el mouse).
   - La tira se arrastra con el mouse y tiene flechas arriba/abajo.
   - La rueda del mouse sobre la tira mueve la PÁGINA, no la tira.
   - El zoom (Photoswipe) sigue funcionando: el slider del theme no se toca por
     dentro, solo se mueve entero y se le prende/apaga la clase a cada slide.
   ============================================================ */
(function () {
  'use strict';

  var MIN = 1024;

  function boton(clase, glifo, chev) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = clase;
    b.innerHTML = chev ? '<span class="tn-chev">' + glifo + '</span>' : glifo;
    return b;
  }

  function fuenteImagen(el) {
    if (!el) return '';
    var img = el.querySelector('img');
    if (!img) return '';
    // Ojo: en lazy sin cargar, currentSrc viene vacío.
    return img.getAttribute('src') || img.getAttribute('data-src') || '';
  }

  function init() {
    if (window.innerWidth < MIN) return;

    var slider = document.querySelector('[data-product-single-media-slider]');
    if (!slider || slider.dataset.sofsGalV2 === '1') return;

    var slides = Array.prototype.slice.call(
      slider.querySelectorAll('.product-gallery__media-slide')
    );
    if (!slides.length) return;

    slider.dataset.sofsGalV2 = '1';

    // --- Miniaturas: las del theme si existen, si no las de cada slide ---
    var thumbsTheme = document.querySelectorAll('#ProductThumbs .product-single__thumbnail, .product-single__thumbnails .product-single__thumbnail');
    var fuentes = slides.map(function (s) {
      var id = s.dataset.id || s.dataset.mediaId;
      var t = null;
      Array.prototype.forEach.call(thumbsTheme, function (x) {
        if (!t && (x.dataset.id === id)) t = x;
      });
      return fuenteImagen(t) || fuenteImagen(s);
    });

    // --- Armado del bloque ---
    var gal = document.createElement('div');
    gal.className = 'sofs-pg';

    var wrap = document.createElement('div');
    wrap.className = 'sofs-pg__thumbs-wrap';

    var strip = document.createElement('div');
    strip.className = 'sofs-pg__thumbs';

    var up = boton('sofs-pg__nav sofs-pg__nav--up is-off', '&#8250;', true);
    var dn = boton('sofs-pg__nav sofs-pg__nav--down', '&#8250;', true);
    up.setAttribute('aria-label', 'Ver fotos anteriores');
    dn.setAttribute('aria-label', 'Ver más fotos');

    wrap.appendChild(up);
    wrap.appendChild(strip);
    wrap.appendChild(dn);

    var main = document.createElement('div');
    main.className = 'sofs-pg__main';

    slider.parentNode.insertBefore(gal, slider);
    gal.appendChild(wrap);
    gal.appendChild(main);
    main.appendChild(slider); // el slider se mueve entero: conserva sus listeners

    var prev = boton('sofs-pg__arrow sofs-pg__arrow--prev', '&#8249;');
    var next = boton('sofs-pg__arrow sofs-pg__arrow--next', '&#8250;');
    prev.setAttribute('aria-label', 'Foto anterior');
    next.setAttribute('aria-label', 'Foto siguiente');
    main.appendChild(prev);
    main.appendChild(next);

    // La fila de miniaturas del theme y el indicador sobran en computador.
    var filaVieja = document.querySelector('#ProductThumbs, .product-single__thumbnails');
    if (filaVieja) filaVieja.classList.add('sofs-pg-hide');
    var indicador = document.querySelector('.pdp-media-indicator');
    if (indicador) indicador.classList.add('sofs-pg-hide');

    // --- Miniaturas ---
    var minis = [];
    fuentes.forEach(function (src, i) {
      var d = document.createElement('div');
      d.className = 'sofs-pg__thumb' + (i === 0 ? ' is-active' : '');
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.draggable = false;
        img.alt = '';
        d.appendChild(img);
      }
      d.addEventListener('click', function () { activar(i); });
      strip.appendChild(d);
      minis.push(d);
    });

    var idx = 0;

    function ajustarAlto() {
      // Las miniaturas quedan al par con la foto grande: reparten el alto exacto de
      // la columna. Si son muchas y no caben, vuelven al alto normal y la tira se desliza.
      var H = strip.clientHeight, n = minis.length;
      if (!H || !n) return;
      var alto = (H - (n - 1) * 10) / n;
      if (alto < 110) alto = 120;
      if (alto > 150) alto = 150;
      minis.forEach(function (m) { m.style.height = alto.toFixed(2) + 'px'; });
    }

    function estadoFlechas() {
      var puede = (strip.scrollHeight - strip.clientHeight) > 2;
      up.classList.toggle('is-off', !puede || strip.scrollTop <= 1);
      dn.classList.toggle('is-off', !puede || strip.scrollTop >= (strip.scrollHeight - strip.clientHeight - 1));
    }

    function verMini(el) {
      // A propósito NO usamos scrollIntoView: ese también mueve el scroll de la página.
      if (!el) return;
      var arriba = el.offsetTop, abajo = arriba + el.offsetHeight;
      if (arriba < strip.scrollTop) strip.scrollTop = arriba;
      else if (abajo > strip.scrollTop + strip.clientHeight) strip.scrollTop = abajo - strip.clientHeight;
    }

    function pintar(i) {
      slides.forEach(function (s, k) { s.classList.toggle('sofs-on', k === i); });
    }

    function activar(i, sinAnim) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      idx = i;
      minis.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
      verMini(minis[i]);
      estadoFlechas();

      if (sinAnim) { pintar(i); return; }

      // Desvanecido: se apaga la foto, y la nueva entra cuando ya cargo y
      // cuando termino de apagarse la anterior (lo que pase de ultimo).
      slider.classList.add('sofs-fade');
      var hecho = false, cargada = false, apagada = false;
      function mostrar() {
        if (hecho) return;
        hecho = true;
        pintar(i);
        slider.classList.remove('sofs-fade');
      }
      function probar() { if (cargada && apagada) mostrar(); }
      setTimeout(function () { apagada = true; probar(); }, 170);
      var im = slides[i].querySelector('img');
      var src = im && (im.getAttribute('src') || im.getAttribute('data-src'));
      if (src) {
        var pre = new Image();
        pre.onload = function () { cargada = true; probar(); };
        pre.onerror = function () { cargada = true; probar(); };
        pre.src = src;
      } else {
        cargada = true;
      }
      setTimeout(mostrar, 1200); // red de seguridad
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); activar(idx - 1); });
    next.addEventListener('click', function (e) { e.preventDefault(); activar(idx + 1); });

    function paso() {
      var t = strip.querySelector('.sofs-pg__thumb');
      return (t ? t.offsetHeight + 10 : 130) * 2;
    }
    up.addEventListener('click', function () { strip.scrollTop -= paso(); });
    dn.addEventListener('click', function () { strip.scrollTop += paso(); });

    strip.addEventListener('scroll', estadoFlechas);
    // La rueda del mouse sobre la tira mueve la PÁGINA, no la tira.
    strip.addEventListener('wheel', function (e) {
      e.preventDefault();
      window.scrollBy(0, e.deltaY);
    }, { passive: false });

    // Arrastre con el mouse
    var on = false, sy = 0, st = 0, movido = false;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      on = true; movido = false; sy = e.clientY; st = strip.scrollTop;
      strip.classList.add('dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!on) return;
      var dy = e.clientY - sy;
      if (Math.abs(dy) > 3) movido = true;
      strip.scrollTop = st - dy;
    });
    window.addEventListener('pointerup', function () {
      if (!on) return;
      on = false;
      strip.classList.remove('dragging');
      setTimeout(function () { movido = false; }, 0);
    });
    strip.addEventListener('click', function (e) {
      if (movido) { e.stopPropagation(); e.preventDefault(); }
    }, true);

    function acomodar() { ajustarAlto(); estadoFlechas(); }
    wrap.addEventListener('mouseenter', estadoFlechas);
    window.addEventListener('load', acomodar);
    window.addEventListener('resize', acomodar);
    setTimeout(acomodar, 400);
    setTimeout(acomodar, 1500);

    // Si el theme cambia la foto destacada (cambio de variante), seguimos ese cambio.
    if (window.MutationObserver) {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t.classList && t.classList.contains('is-selected')) {
            var k = slides.indexOf(t);
            if (k > -1 && k !== idx) activar(k);
            break;
          }
        }
      });
      slides.forEach(function (s) { obs.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    }

    ajustarAlto();
    activar(0, true);
  }

  function arranque() { init(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranque);
  } else {
    arranque();
  }
  // El theme puede rearmar la galería tarde (variantes, AJAX).
  setTimeout(arranque, 800);
  setTimeout(arranque, 2000);
})();
